import { HeartIcon } from '@heroicons/react/24/outline';
import classNames from 'classnames';
import React from 'react';
export default function Favorite({ selected, onToggle }) {
    return (React.createElement(HeartIcon, { onClick: onToggle, className: classNames('w-5 h-5 text-red-400 cursor-pointer', {
            'fill-red-400': selected,
            'fill-white hover:fill-red-400': !selected,
        }) }));
}
